module.exports = __webpack_public_path__ + "img/no-data.08756f6c.png";